import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

import './App.scss';

import commonConstant from './common/_commonConstant';
import { SideBar, Navbar, Footer } from './components';
import { history, isAndroid, Modal } from './helpers';
import { hideErrorMessage } from './actions';
import {
  NotFound,
  AccountingReport,
  ServerError,
  Login,
  ContactUs,
  SelectBuilding,
  CheckRedirect,
  Logout,
  SearchVehicleLicensePlate,
  VehicleLicensePlate,
  OperationReport,
  UserManagement,
  ExportOperationReport,
  ManageMembership,
  OperationDashboard,
  TenantManagement,
  CreateBuilding,
  EditBuilding,
  ManageTenantMemberShip,
  ParkingDayConfig,
  CustomDayConfig,
} from './pages';

class ErrorMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showModal': false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { errorMessage } = this.props;

    if (nextProps.errorMessage && nextProps.errorMessage !== errorMessage) {
      if (nextProps.errorMessage.type === commonConstant.SHOW_ERROR_MESSAGE) {
        return this.setState({ 'showModal': true });
      }
      return this.setState({ 'showModal': false });
    }
  }

  handleShowModal = () => this.props.dispatch(hideErrorMessage());

  render() {
    const { errorMessage } = this.props;
    const { showModal } = this.state;

    return (
      <Modal
        show={showModal}
        headerTemplate="a"
        handleToggle={this.handleShowModal}
      >
        <div className="ErrorMessage">
          <div className="box">
            <div className="title">
              Something went wrong.
            </div>
            {errorMessage.status && (<div className="error-status"><span className="error">Error status:</span> {errorMessage.status}</div>)}
            {errorMessage.errorMessage && (<div className="error-msg"><span className="error">Error message:</span> {errorMessage.errorMessage}</div>)}
            <div className="description">please try again or feel free to contact us if the problem persists.</div>
            <div className="box-btn">
              <Button className="btn-primary btn-back" id="btn-back" onClick={this.handleShowModal}>
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

ErrorMessage.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'errorMessage': PropTypes.shape({
    'status': PropTypes.any,
    'errorMessage': PropTypes.any,
    'type': PropTypes.string,
  }),
};

const mapStateToProps = ({ errorMessage }) => ({ errorMessage });

const ErrorMessages = connect(mapStateToProps)(ErrorMessage);

const MainLayout = (props) => (
  <div className="MainLayout">
    <Navbar />
    <SideBar />
    <div className={`box-page${isAndroid() ? ' x2' : ''}`}>
      <Switch>
        <Route sensitive strict exact path={commonConstant.pathSelectBuilding} component={SelectBuilding} />
        <Route sensitive strict exact path={commonConstant.pathAccountingReport} component={AccountingReport} />
        <Route sensitive strict exact path={commonConstant.pathSearchVehicleLicensePlate} component={SearchVehicleLicensePlate} />
        <Route sensitive strict exact path={commonConstant.pathParkingStatus} component={VehicleLicensePlate} />
        <Route sensitive strict exact path={commonConstant.pathOperationReport} component={OperationReport} />
        <Route sensitive strict exact path={commonConstant.pathUserManagement} component={UserManagement} />
        <Route sensitive strict exact path={commonConstant.pathExportOperationReport} component={ExportOperationReport} />
        <Route sensitive strict exact path={commonConstant.pathManageMembership} component={ManageMembership} />
        <Route sensitive strict exact path={commonConstant.pathTenantManagement} component={TenantManagement} />
        <Route sensitive strict exact path={commonConstant.pathOperationDashboard} component={OperationDashboard} />
        <Route sensitive strict exact path={commonConstant.pathCreateBuilding} component={CreateBuilding} />
        <Route sensitive strict exact path={commonConstant.pathEditDraftedBuilding} component={CreateBuilding} />
        <Route sensitive strict exact path={commonConstant.pathOnboardForm} component={EditBuilding} />      
        <Route sensitive strict exact path={commonConstant.pathManageTenantMembership} component={ManageTenantMemberShip} />   
        <Route sensitive strict exact path={commonConstant.pathParkingDayConfig} component={ParkingDayConfig} />     
        <Route sensitive strict exact path={commonConstant.pathCustomDayConfig} component={CustomDayConfig} />              
      </Switch>
    </div>
    <Footer match={props.match} />
  </div>
);

MainLayout.propTypes = {
  'match': PropTypes.shape({}),
};

export default () => (
  <Router history={history}>
    <div className="App">
      <ErrorMessages />
      <Switch>
        <Route sensitive strict exact path={commonConstant.pathCheckRedirect} component={CheckRedirect} />
        <Route sensitive strict exact path={commonConstant.pathLogin} component={Login} />
        <Route sensitive strict exact path={commonConstant.pathLogout} component={Logout} />
        <Route sensitive strict exact path={commonConstant.pathContactUs} component={ContactUs} />
        <Route
          sensitive
          strict
          exact
          path={[
            commonConstant.pathAccountingReport,
            commonConstant.pathSelectBuilding,
            commonConstant.pathSearchVehicleLicensePlate,
            commonConstant.pathParkingStatus,
            commonConstant.pathOperationReport,
            commonConstant.pathUserManagement,
            commonConstant.pathExportOperationReport,
            commonConstant.pathManageMembership,
            commonConstant.pathTenantManagement,
            commonConstant.pathOperationDashboard,
            commonConstant.pathCreateBuilding,
            commonConstant.pathEditDraftedBuilding,
            commonConstant.pathOnboardForm,
            commonConstant.pathManageTenantMembership,
            commonConstant.pathParkingDayConfig,
            commonConstant.pathCustomDayConfig,
          ]}
          component={MainLayout}
        />
        <Route sensitive strict exact path={commonConstant.pathServerError} component={ServerError} />
        <Route component={NotFound} />
      </Switch>
    </div>
  </Router>
);
